var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64648 7.25C7.32002 6.09575 6.25878 5.25 5 5.25C3.48122 5.25 2.25 6.48122 2.25 8C2.25 9.51878 3.48122 10.75 5 10.75C6.25878 10.75 7.32002 9.90425 7.64648 8.75H20C20.4142 8.75 20.75 8.41421 20.75 8C20.75 7.58579 20.4142 7.25 20 7.25H7.64648ZM3.75 8C3.75 7.30964 4.30964 6.75 5 6.75C5.69036 6.75 6.25 7.30964 6.25 8C6.25 8.69036 5.69036 9.25 5 9.25C4.30964 9.25 3.75 8.69036 3.75 8Z",
    fill: "#00322E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3535 16.75C16.68 17.9043 17.7412 18.75 19 18.75C20.5188 18.75 21.75 17.5188 21.75 16C21.75 14.4812 20.5188 13.25 19 13.25C17.7412 13.25 16.68 14.0957 16.3535 15.25H4C3.58579 15.25 3.25 15.5858 3.25 16C3.25 16.4142 3.58579 16.75 4 16.75H16.3535ZM19 14.75C18.3096 14.75 17.75 15.3096 17.75 16C17.75 16.6904 18.3096 17.25 19 17.25C19.6904 17.25 20.25 16.6904 20.25 16C20.25 15.3096 19.6904 14.75 19 14.75Z",
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFilter);
export default __webpack_public_path__ + "static/media/icn_filter.8eeecc45ecd5baabb2232e36d4c6bdec.svg";
export { ForwardRef as ReactComponent };